import style from './IconStatusAvatar.module.css';
import { FaHeart } from 'react-icons/fa';
import { BsCake2Fill } from 'react-icons/bs';
import { GrUserNew } from 'react-icons/gr';
import { useDispatch, useSelector } from 'react-redux';
import { selectFanList } from '../../../redux/fans/selectors';
import { useEffect, useMemo, useState } from 'react';
import { addFan, deleteFan } from '../../../redux/fans/operations';
import {
  selectIsAdmin,
  selectIsManager,
  selectUser,
} from '../../../redux/auth/selectors';
import { FaPersonCircleCheck } from 'react-icons/fa6';
import { FaHeartCircleCheck } from 'react-icons/fa6';
import { FaHeartCircleMinus } from 'react-icons/fa6';
import { FaPersonCircleQuestion } from 'react-icons/fa6';
import { FaPersonCircleMinus } from 'react-icons/fa6';
import { FaPersonCircleExclamation } from 'react-icons/fa6';
import { RiMoneyEuroCircleFill } from 'react-icons/ri';
import { Button, Input, InputNumber, Modal, Tooltip } from 'antd';
import {
  updateFreeUser,
  updateUserVerificationStatus,
} from '../../../api/freeUsers';
import toast from 'react-hot-toast';
import {
  removeItem,
  updateFilterItemFreeUser,
} from '../../../redux/onlineLadies/slice';
import { updatePaidUser } from '../../../api/paidUsers';
function checkStatus(status, user) {
  return status === user?.verifiedStatus;
}

const IconStatusAvatar = ({
  userId,
  userBirthday,
  registeredUser,
  userData,
}) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const isAdmin = useSelector(selectIsAdmin);
  const isManager = useSelector(selectIsManager);
  const isPaidUser = userData?.typeAccount === 'paidUser';
  const isFreeUser = userData?.typeAccount === 'freeUser';
  const [isHover, setIsHover] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [inputText, setInputText] = useState('');
  const [balance, setBalance] = useState(userData?.balance || 0);
  // useEffect(() => {
  //   setBalance(user?.balance);
  // }, [user?.balance]);

  const handleOpenModal = () => {
    if (!isAdmin) return;
    setInputText(userData?.verifiedComment); // Reset input text to current tooltip text
    setIsModalOpen(true);
  };

  const handleSave = () => {
    updateFreeUser(userId, { verifiedComment: inputText });
    dispatch(updateFilterItemFreeUser({ userId, verifiedComment: inputText }));
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false); // Close modal without saving
  };

  const handleInputChange = e => {
    setInputText(e.target.value);
  };

  const fanList = useSelector(selectFanList);
  const isFan = useMemo(() => {
    return fanList.find(el => el.fanId === userId);
  }, [fanList, userId]);

  const toggleFan = () => {
    if (isFan) {
      dispatch(deleteFan(isFan._id));
    } else {
      dispatch(
        addFan({
          fanId: userId,
          userId: user._id,
        }),
      );
    }
  };

  const birthday = new Date(userBirthday);
  const currentDay = new Date();
  const hasBirthday =
    birthday.getDate() === currentDay.getDate() &&
    birthday.getMonth() === currentDay.getMonth();

  const timeDifference = currentDay - new Date(registeredUser);
  const isNewUser = timeDifference <= 720 * 60 * 60 * 1000;

  const handleChangeNewUserStatus = status => {
    if (!isAdmin && isManager) return;
    toast.promise(updateUserVerificationStatus(userId, status), {
      loading: 'Wait.User Status is updating',
      success: `Congratulations. User Status is updated to ${status}`,
      error: 'ups.Something went wrong',
    });
    dispatch(removeItem(userId));
  };

  const handleChangePaidUserStatus = () => {
    if (!isAdmin && isManager) return;
    const status = userData.verifiedStatus;
    const newStatus = status === 'active' ? 'disabled' : 'active';
    toast.promise(updatePaidUser({ verifiedStatus: newStatus }, userId), {
      loading: 'Wait.User Status is updating',
      success: `Congratulations. User Status is updated to ${status}`,
      error: 'ups.Something went wrong',
    });
    dispatch(removeItem(userId));
  };

  const handleSaveBalance = () => {
    if (!isAdmin) {
      return handleCancel();
    }
    toast
      .promise(updatePaidUser({ balance }, userId), {
        loading: 'Wait.User Balance is updating',
        success: `Congratulations. User Balance has been updated`,
        error: 'ups.Something went wrong',
      })
      .then(handleCancel);
  };

  if (isAdmin || isManager) {
    return (
      <div className={style.iconServicesContainer}>
        {(isAdmin || isManager) && !isPaidUser && (
          <div
            className={style.bgIconContainer}
            onClick={() => handleChangeNewUserStatus('unverified')}
          >
            <Tooltip placement="top" title="New Free User Unverified">
              <FaPersonCircleQuestion
                className={style.unapprovedUser}
                style={{
                  color: checkStatus('unverified', userData) ? 'red' : 'white',
                }}
              />
            </Tooltip>
          </div>
        )}
        {!isAdmin && !isManager && checkStatus('new', userData) && (
          <div className={style.bgIconContainer}>
            <Tooltip placement="top" title="New Free User">
              <FaPersonCircleQuestion
                className={style.unapprovedUser}
                style={{
                  color: 'yellow',
                }}
              />
            </Tooltip>
          </div>
        )}

        {((userData?.verifiedComment?.length && !isAdmin) ||
          (isAdmin && !isPaidUser)) && (
          <div className={style.bgIconContainer} onClick={handleOpenModal}>
            <Tooltip placement="top" title={userData?.verifiedComment}>
              <FaPersonCircleExclamation
                className={style.needsEditionUser}
                style={{
                  color: userData?.verifiedComment?.length ? 'red' : 'white',
                }}
              />
            </Tooltip>
          </div>
        )}
        {!isPaidUser && (
          <Modal
            title="Edit Tooltip Text"
            open={isModalOpen}
            onOk={handleSave}
            onCancel={handleCancel}
            footer={[
              <Button key="cancel" onClick={handleCancel}>
                Cancel
              </Button>,
              <Button key="save" type="primary" onClick={handleSave}>
                Save
              </Button>,
            ]}
          >
            <Input
              value={inputText}
              onChange={handleInputChange}
              placeholder="Enter tooltip text"
            />
          </Modal>
        )}

        {!isPaidUser && (
          <div
            className={style.bgIconContainer}
            onClick={() => handleChangeNewUserStatus('verified')}
          >
            <Tooltip
              placement="top"
              title={
                checkStatus('verified', userData)
                  ? 'User is Verified'
                  : 'Enable Free User'
              }
            >
              <FaPersonCircleCheck
                className={style.enableUser}
                style={{
                  color: checkStatus('verified', userData) ? 'green' : 'white',
                }}
              />
            </Tooltip>
          </div>
        )}

        {(isAdmin || isManager) && !isPaidUser && (
          <div
            className={style.bgIconContainer}
            onClick={() => handleChangeNewUserStatus('disabled')}
          >
            <Tooltip placement="top" title="Disable  User">
              <FaPersonCircleMinus
                className={style.disableUser}
                style={{
                  color: checkStatus('disabled', userData) ? 'red' : 'white',
                }}
              />
            </Tooltip>
          </div>
        )}

        {(isAdmin || isManager) && isPaidUser && (
          <div
            className={style.bgIconContainer}
            onClick={() => handleChangePaidUserStatus()}
          >
            <Tooltip
              placement="top"
              title={
                checkStatus('disabled', userData)
                  ? 'Enable User'
                  : 'Disable User'
              }
            >
              <FaPersonCircleMinus
                className={style.disableUser}
                style={{
                  color: checkStatus('disabled', userData) ? 'red' : 'white',
                }}
              />
            </Tooltip>
          </div>
        )}

        {userData?.typeAccount === 'paidUser' && (
          <div className={style.bgIconContainer} onClick={handleOpenModal}>
            <Tooltip placement="top" title={`${userData?.balance} Coins`}>
              <RiMoneyEuroCircleFill className={style.eurIcon} />
            </Tooltip>
          </div>
        )}
        {isPaidUser && (
          <Modal
            title="Change Balance"
            open={isModalOpen}
            onOk={handleSave}
            onCancel={handleCancel}
            footer={[
              <Button key="cancel" onClick={handleCancel}>
                Cancel
              </Button>,
              <Button key="save" type="primary" onClick={handleSaveBalance}>
                Save
              </Button>,
            ]}
          >
            <InputNumber
              value={balance}
              min={0}
              onChange={x => {
                setBalance(x);
              }}
              placeholder="Enter tooltip text"
            />
          </Modal>
        )}
      </div>
    );
  }

  return (
    <div className={style.iconServicesContainer}>
      {isNewUser && (
        <div className={style.bgIconContainer}>
          <GrUserNew className={style.iconNewUser} />
        </div>
      )}
      {hasBirthday && (
        <div className={style.bgIconContainer}>
          <BsCake2Fill className={style.iconBirthday} />
        </div>
      )}
      {(isPaidUser || isFreeUser) && (
        <div
          className={style.bgIconContainer}
          onClick={toggleFan}
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
          {!isFan ? (
            <FaHeart className={style.iconFavorite} />
          ) : !isHover ? (
            <FaHeartCircleCheck className={style.iconIsFan} />
          ) : (
            <FaHeartCircleMinus className={style.iconFavorite} />
          )}
        </div>
      )}
    </div>
  );
};

export default IconStatusAvatar;
